import HttpServiceSingleton from '../HttpService/HttpService';

const API_BASE = process.env.REACT_APP_RULES_API ?? '';

// Interface for getUsers API request body
export interface GetUsersRequestBody {
  conditions: {
    operation: string;
    objectName: string;
    objectValue: string | string[];
  }[];
  columns?: string[];
  entitlementValueKey?: number | string; // optional - when provided, matches access
  hasAccess?: boolean; // optional - filters users by access status
  pagination?: {
    max?: number; // default 5
    page?: number; // default 1
  };
}

// Interface for user data returned by getUsers API
export interface User {
  userkey: number;
  firstname: string;
  lastname: string;
  username?: string;
  title: string;
  manager: string;
  country?: string;
  city?: string;
  costcenter?: string;
  departmentname?: string;
  owner?: string;
  employeetype?: string;
  accessStatus?: boolean; // might not be in original API, but added for UI
}

/**
 * Service for user-related API operations
 */
const UserService = {
  /**
   * Fetches users based on conditions and optional entitlement access
   * @param requestBody - Request body with conditions, columns, and pagination
   * @returns Promise with array of users
   */
  async getUsers(requestBody: GetUsersRequestBody): Promise<{
    users: User[];
    pagination: { nextPage?: number; currentPage: number };
  }> {
    const url = `${API_BASE}/ECMv6/api/intelligence/recommendations/getUsers`;

    const response = (await HttpServiceSingleton.post(url, requestBody)) as {
      success: boolean;
      data: {
        data: User[];
        pagination: {
          nextPage?: number;
          currentPage: number;
        };
      };
    };

    return {
      users: response.data.data,
      pagination: response.data.pagination,
    };
  },
};

export default UserService;
